import { IMaterialExposure } from '../../../sp-types/netExposureType';
import { FormatToShortPriceTemplate } from '../../../utils/FormatValue';
import React from 'react';
interface ExposureCalculationProps {
  totalAmounts: IMaterialExposure;
  netExposure: number;
  exposureColor?: string;
}

export const getExposureCalculation: React.FC<ExposureCalculationProps> = ({
  netExposure,
  totalAmounts: { financialPositions, inventorySum, futureOrder },
  exposureColor,
}) => (
  <div className="p-3 bg-white text-sm font-medium rounded-lg shadow-lg border border-gray-200">
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <span className="text-gray-600">Demand</span>
        <span className="text-gray-900 font-semibold">{FormatToShortPriceTemplate(futureOrder)}</span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-gray-600">Supply</span>
        <span className="text-gray-900 font-semibold">- {FormatToShortPriceTemplate(inventorySum)}</span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-gray-600">Hedges</span>
        <span className="text-gray-900 font-semibold">- {FormatToShortPriceTemplate(financialPositions)}</span>
      </div>
      <div className="pt-2 mt-2 border-t border-gray-300">
        <div className="flex justify-between items-center">
          <span className="text-gray-700 font-semibold">Net Exposure</span>
          <span className="font-bold text-base" style={{ color: exposureColor || '#000' }}>
            {FormatToShortPriceTemplate(netExposure)}
          </span>
        </div>
      </div>
    </div>
  </div>
);
